import { WORKFLOW_PATH } from '../url';
import ErrorSwitchCase from './ErrorHandlerService';
import HttpService from './HttpService';

const _axios = HttpService.getAxiosClient();

const buildParams = (filters = {}, pageNumber = 0, pageSize = 5) => {
  const params = { pageNumber, pageSize };
  if (filters.id != null) params.id = filters.id;
  if (filters.status) params.status = filters.status;
  if (filters.empId) params.empId = filters.empId;
  if (filters.quotaYear != null && filters.quotaYear !== '') {
    params.quotaYear = filters.quotaYear;
  }
  if (filters.quarterIndex != null && filters.quarterIndex !== '') {
    params.quarterIndex = filters.quarterIndex;
  }
  if (filters.requestDateFrom) params.requestDateFrom = filters.requestDateFrom;
  if (filters.requestDateTo) params.requestDateTo = filters.requestDateTo;
  if (filters.searchString) params.searchString = filters.searchString;
  return params;
};

/** Employee: request additional WFH quota (additional days for a quarter). */
export const createAdditionalWfhQuotaRequest = async (payload) => {
  try {
    const response = await _axios.post(
      `${WORKFLOW_PATH}/additional-wfh/quota-requests`,
      payload,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data || error.response);
  }
};

export const getAdditionalWfhQuotaRequests = async (
  employeeId,
  filters = {},
  pageNumber = 0,
  pageSize = 5,
) => {
  try {
    const response = await _axios.get(
      `${WORKFLOW_PATH}/additional-wfh/quota-requests/users/${employeeId}`,
      { params: buildParams(filters, pageNumber, pageSize) },
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

/** Senior Manager inbox — approver is always the authenticated user. */
export const getAdditionalWfhQuotaRequestsForApprover = async (
  filters = {},
  pageNumber = 0,
  pageSize = 5,
) => {
  try {
    const response = await _axios.get(
      `${WORKFLOW_PATH}/additional-wfh/quota-requests/approver/me`,
      { params: buildParams(filters, pageNumber, pageSize) },
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const cancelAdditionalWfhQuotaRequest = async (id, employeeId) => {
  try {
    const response = await _axios.delete(
      `${WORKFLOW_PATH}/additional-wfh/quota-requests/${id}/user/${employeeId}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const approveAdditionalWfhQuotaRequest = async (id) => {
  try {
    const response = await _axios.put(
      `${WORKFLOW_PATH}/additional-wfh/quota-requests/${id}/approve`,
      {},
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data || error.response);
  }
};

export const rejectAdditionalWfhQuotaRequest = async (id) => {
  try {
    const response = await _axios.put(
      `${WORKFLOW_PATH}/additional-wfh/quota-requests/${id}/reject`,
      {},
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data || error.response);
  }
};

/** Direct reportees of the authenticated Senior Manager (Reporting Manager link). */
export const getAdditionalWfhReportees = async (
  searchString = '',
  pageNumber = 0,
  pageSize = 100,
) => {
  try {
    const response = await _axios.get(
      `${WORKFLOW_PATH}/additional-wfh/reportees`,
      { params: buildParams({ searchString }, pageNumber, pageSize) },
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};
